<template>
  <div class="chat-container-wrapper">
    <div class="chat-container">
      <div class="chat-messages" ref="messagesContainer">
        <div
          v-for="(message, index) in messages"
          :key="index"
          class="chat-message"
          :class="{ 'user-message': message.isUser }"
        >
          <img
            v-if="message.isUser"
            class="logo"
            :src="require('@/assets/images/profile.svg')"
          />
          <img
            v-if="!message.isUser"
            class="logo"
            :src="require('@/assets/images/solvpath.svg')"
          />
          <div class="message-text" v-html="message.text"></div>
        </div>
      </div>
      <div class="chat-input">
        <input
          v-model="currentMessage"
          @keyup.enter="sendMessage"
          placeholder="Send a message..."
        />
        <b-button :disabled="!currentMessage || !currentMessage.length"
                @click="sendMessage" class="no-outline-btn btn-primary"
        >Send</b-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import {mapGetters, mapState} from 'vuex'
import AuthToken from '@/components/AuthToken.vue'

export default {
  components: {AuthToken},
  computed: {
    ...mapState(['session', 'campaign', 'token']),
    ...mapGetters(['isSessionUserKnown'])
  },
  data() {
    return {
      messages: [
        {
          text: "Hi there! How may I help you?", // Initial greeting message
          isUser: false
        }
      ],
      currentMessage: "",
      processing: false
    };
  },
  methods: {
    sendMessage() {
      if (this.currentMessage.trim() === "") return;
      this.processing = true
      const userMessage = {
        text: this.currentMessage,
        isUser: true
      }

      this.messages.push(userMessage);
      this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight + 100;
      this.currentMessage = ""
      const url = (process.env.VUE_APP_CHAT_BOT_URL || 'http://localhost:4200/') + 'v1/chats'

      fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.token}`
        },
        body: JSON.stringify({
          "parent_session_id": this.session.parent_session_id || this.session.id,
          "session_id": this.session.id,
          "campaign_id": this.campaign.id,
          "account_id": this.campaign.account_id,
          "question": this.messages[this.messages.length - 1].text
        })
      }).then(async (response) => {
        if (response.ok) {
          const index = this.messages.length
          const reader = response.body.getReader()

          while (true) {
            const { done, value } = await reader.read()
            if (value && value.length > 0) {
              for(let i = 0; i < value.length; i++) {
                let newMessage = ""
                if (value[i] === 10) {
                  newMessage += '</p><p>'
                } else {
                  newMessage +=  String.fromCharCode.apply(null, [value[i]])
                }

                if (this.messages[index]) {
                  this.messages[index].text += newMessage
                } else {
                  this.messages.push({
                    text: '<p>' + newMessage,
                    isUser: false
                  })
                }
                this.messages[index].text = this.messages[index].text
                  .replaceAll('#$#', '')
                  .replaceAll(/ MESSAGE_ID:[0-9]\d+ /gm, '')
                  .replaceAll('{brand}.solvpath.com', window.location.host)
                this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight + 100;
              }
            }
            if (done) {
              this.messages[index].text += '</p>'
              return;
            }
          }
        } else {

          if (response.status === 401) {  // user token is invalid
            this.$store.commit('logout')
          } else {
            this.messages.push({
              text: "Sorry, we are unable to understand your query. Please try again",
              isUser: false
            })
          }

        }
      }).catch((error)=> console.error(error))
        .finally(() => {
          localStorage.setItem('chat', JSON.stringify(this.messages))
          this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight + 100;
        })
    }
  },
  created() {
    const messages = localStorage.getItem('chat')
    if (messages) {
      this.messages = JSON.parse(messages)
      setTimeout(() => {
        this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
      }, 100)
    }
  }
};
</script>

<style scoped>
.chat-container-wrapper {
  display: flex;
  justify-content: center;
  align-content: center;
  padding-top: 4rem;
}

.chat-container {
  display: flex;
  flex-direction: column;
  border: 1px solid #ccc;
  border-radius: 10px;
  overflow: hidden;
  height: 65vh;
  width: 90%;
  margin: auto;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}

.chat-message {
  margin-bottom: 10px;
  padding: 8px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  width: 100%;
}

.message-text {
  white-space: pre-wrap;
  overflow: hidden;
}

@keyframes typing {
  from { width: 0 }
  to { width: 100% }
}

.user-message {
  background-color: #cbe1ed;
}

.logo {
  height: 20px;
  width: 20px;
  align-self: flex-start;
  margin-right: 10px;
  margin-top: 5px;
}

.chat-input {
  display: flex;
  align-items: center;
  padding: 10px;
}

input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: rgb(246, 245, 245);
}

button {
  margin-left: 10px;
  padding: 8px 12px;
  background-color: #4c68af;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
